<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isLoading"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm"
        role="status"
        aria-live="polite"
        aria-label="Carregando página"
      >
        <div class="flex flex-col items-center">
          <!-- Logo -->
          <div class="mb-6 animate-pulse">
            <img :src="nexxoLogo" alt="Nexxo" class="h-16" />
          </div>

          <!-- Spinner -->
          <div class="relative w-12 h-12">
            <div
              class="absolute inset-0 border-4 border-violet-200 dark:border-violet-900 rounded-full"
            ></div>
            <div
              class="absolute inset-0 border-4 border-transparent border-t-violet-600 dark:border-t-violet-400 rounded-full animate-spin"
            ></div>
          </div>

          <!-- Texto opcional -->
          <p v-if="showText" class="mt-4 text-sm text-gray-600 dark:text-gray-400 animate-pulse">
            Carregando...
          </p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { usePageLoader } from '@/composables/usePageLoader'
import { computed } from 'vue'

import nexxoLogo from '@/assets/images/nexxo/nexxo-logo.png'

const pageLoader = usePageLoader()
const isLoading = computed(() => pageLoader.isLoading.value)

withDefaults(
  defineProps<{
    showText?: boolean
  }>(),
  {
    showText: false,
  },
)
</script>
